import axios from 'axios'

import store from 'store'
import handleNetworkError from 'actions/network'
import { refreshUserToken } from 'actions/user'
import { getAPIEndpoint } from 'utils/apiConstants'
import { logout } from 'actions/application'

const baseURL = `${getAPIEndpoint()}/webtransporter`
const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
})

const checkForToken = () => `bearer ${store.getState().user && store.getState().user.access_token}`

api.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: { ...config.headers,
        Authorization: checkForToken(),
        'Content-Type': 'application/json',
      },
    }
    return newConfig
  },
  error =>
    Promise.reject(error)
  ,
)

api.interceptors.response.use(
  response => (
    response
  ), error => {
    if (error.response) {
      const statusCode = error.response.status
      if (statusCode === 401) {
        store.dispatch(logout())
      } else if (statusCode === 403) {
        store.dispatch(refreshUserToken())
      }
      store.dispatch(handleNetworkError(error.response.status, error.response.data))
      return Promise.reject(error)
    }
    store.dispatch(handleNetworkError(0))
    return Promise.reject(error)
  })


export default api
